// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","809":"account"}[chunkId] + "." + {"18":"e86d4f9f","809":"8f6d25a0"}[chunkId] + ".css";
};